import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { textType } from 'resources/AppTexts';
import { useState } from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AppColors } from 'resources/AppColors';
import { useDispatch } from 'react-redux';
import FormToDisplay from './FormToDisplay';
import DialogMonitoring from 'components/DialogMonitoring';
import {
  CommonTexts,
  ConfigFormsLabels,
  configFormsTexts,
  LabelsLogOut,
} from 'locale/es';
import TextMonitoring from 'components/TextMonitoring';
import CustomDialog from 'components/Dialogs/MasterDialog';
import NoDataTableBody from 'components/TableMonitoring/Body/NoDataTableBody';
import Loader from 'components/Loader/Loader';
import FormForm from './FormForm';
import {
  createFormAction,
  updateFormAction,
} from 'redux/reducers/configFormsReducer';
import { useFilter } from 'hooks/useFilter';
import FilterTable from 'components/TableMonitoring/Toolbar/Filter';
import { useFilterContext } from 'context/FilterContext';

const tableHeaders = [
  { name: ConfigFormsLabels.FORM_NAME, value: 'formName' },
  { name: ConfigFormsLabels.FORM_ID, value: 'formId' },
  { name: ConfigFormsLabels.STUDY_ID, value: 'studyId' },
  { name: ConfigFormsLabels.TAG, value: 'formTag' },
  { name: CommonTexts.DESCRIPTION, value: 'formDescription' },
  { name: ConfigFormsLabels.START_DATE, value: 'startDate' },
  { name: ConfigFormsLabels.END_DATE, value: 'endDate' },
];
const FormsTable = ({ entityId, formsConfig, actions, canCreate }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [formTag, setFormTag] = useState('');

  const dispatch = useDispatch();

  const { selectedFilter, searchTerm } = useFilterContext();

  const { data, loading, error } = formsConfig;

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);

  const handleShowDeleteModal = (formToDeleteTag) => {
    if (formToDeleteTag) {
      setFormTag(formToDeleteTag);
    } else {
      setFormTag('');
    }
    setShowDeleteModal((prevState) => !prevState);
  };

  const handleOnConfirmDeleteForm = () => {
    dispatch(actions.remove(entityId, formTag));
    setShowDeleteModal(false);
    setFormTag('');
  };

  const handleShowEditModal = (form) => {
    setShowEditModal(!showEditModal);
    if (form) {
      setFormTag(form.formTag);
    } else {
      setFormTag('');
    }
  };

  const handleShowAddModal = () => {
    setShowAddModal(!showAddModal);
  };

  if (loading) {
    return <Loader message={configFormsTexts.LOADING} pt={32} />;
  }

  return (
    <>
     <FilterTable data={data} tableHeaders={tableHeaders} />
      <TableContainer component={Paper}>
        <Table aria-label='simple table'>
          <TableHead>
            <TableRow>
            {adaptedTableHeaders.map((header) => (
                <TableCell align='left' key={header}>
                  <Typography variant='subtitle'>{header}</Typography>
                </TableCell>
              ))}
              <TableCell align='center'>
              {canCreate && (
                  <IconButton onClick={handleShowAddModal} size='large'>
                    <AddCircleIcon sx={{ fill: AppColors.PRIMARY }} />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 &&
             (selectedFilter && !searchTerm ? data : filteredData).map((form) => (
               <FormToDisplay
                 key={form.id}
                 form={form}
                 handleShowEditModal={handleShowEditModal}
                 handleShowDeleteModal={handleShowDeleteModal}
                 canEditDelete={canCreate} />
             ))}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.length === 0 && (
        <NoDataTableBody
        entity={entityId}
        noDataMessage={
          canCreate
            ? configFormsTexts.NO_DATA
            : configFormsTexts.NO_DATA_PATIENT
        }
      />
      )}
       {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
        <NoDataTableBody
          entity={entityId}
          noDataMessage={configFormsTexts.NO_DATA_FILTERS}
        />
      )}
      <CustomDialog
        title={configFormsTexts.CREATED_TITLE}
        show={showAddModal}
        handleShow={handleShowAddModal}
      >
        <FormForm
          entityId={entityId}
          setShowModal={setShowAddModal}
          onSubmit={createFormAction}
          dataForm={data}
        />
      </CustomDialog>
      <CustomDialog
        title={configFormsTexts.EDITED_TITLE}
        show={showEditModal}
        handleShow={handleShowEditModal}
      >
        <FormForm
          entityId={entityId}
          isEdit={true}
          setShowModal={setShowEditModal}
          onSubmit={updateFormAction}
          selectedFormTag={formTag}
          dataForm={data}
        />
      </CustomDialog>
      {showDeleteModal && (
        <DialogMonitoring
          textCancelButton={LabelsLogOut.CANCEL}
          title={configFormsTexts.DELETED_TITLE}
          textConfirmButton={CommonTexts.DELETE}
          buttonColor={AppColors.RED}
          show={showDeleteModal}
          handleShow={handleShowDeleteModal}
          handleConfirm={handleOnConfirmDeleteForm}
        >
          <Grid>
            <TextMonitoring
              color={AppColors.PRIMARY}
              type={textType.BODY}
              text={configFormsTexts.DELETED_CONFIRM}
            />
          </Grid>
        </DialogMonitoring>
      )}
    </>
  );
};


export default FormsTable;
